import {NgModule} from '@angular/core';

import {RowCellViewComponent} from './row-cell-view.component';

@NgModule({
  declarations: [RowCellViewComponent],
  exports: [RowCellViewComponent],
})
export class RowCellViewModule {}
